export default "__VITE_ASSET__DUn5OQYx__"